import moment from 'moment'

const filtro = (data) => {
	return data ? moment.utc(data).local().format('DD/MM/YYYY') : '--'
}

export default filtro
